// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-skeleton{position:relative;z-index:100;width:1182px;margin:0 auto}.vue-skeleton ul{list-style:none}.vue-skeleton li{padding:42px 36px 28px}.vue-skeleton li .title{width:35%}.vue-skeleton li .time,.vue-skeleton li .title{height:36px;background-color:#f2f2f2;margin-bottom:20px}.vue-skeleton li .time{width:65%}.vue-skeleton li .teacher{width:100%;height:36px;background-color:#f2f2f2}", ""]);
// Exports
module.exports = exports;
